import React from 'react';
import { sizeMap, IIconProps } from './types';

export const ArrowForward = ({ className, size = 'medium' }: IIconProps) => (
  <svg className={className} width={sizeMap[size].width} viewBox="0 0 24 24" fill="none">
    <path
      d="M4 3L20 12L4 21"
      stroke="currentcolor"
      strokeWidth={sizeMap[size].strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
